import { lazy, Suspense } from 'react'

import { useTranslate } from 'lib/tolgee'

import { translations } from './player.i18n'
import type { IPlayerViewProps } from './player.types'

import './player.styles.scss'

const ReactPlayer = lazy(() => import('react-player'))

export const PlayerView = ({
  url,
  playing,
  hasError,
  onPlayerPlay,
  onPlayerPause,
  onPlayerError,
}: IPlayerViewProps) => {
  const t = useTranslate()

  return (
    <div className="player-component">
      <div className="player-wrapper">
        {hasError && <div className="player-error">{t(translations.playbackError)}</div>}
        {!hasError && (
          <Suspense fallback={null}>
            <ReactPlayer
              src={url}
              className="react-player"
              controls
              playing={playing}
              width="100%"
              height="100%"
              onPlay={onPlayerPlay}
              onPause={onPlayerPause}
              onError={onPlayerError}
            />
          </Suspense>
        )}
      </div>
    </div>
  )
}
